
import LazyHydrate from "vue-lazy-hydration";
import SpVideo from "~/components/v2/splash/sp-video.vue";
import SpVideoForm from "~/components/v2/splash/sp-video-form.vue";
import cScrollBtn from "~/components/v2/ui/c-scroll-btn.vue";
import spCarouselByType from "~/components/v2/splash/sp-carousel-by-type.vue";

export default {
  components: {
    SpVideo,
    LazyHydrate,
    SpVideoForm,
    cScrollBtn,
    spCarouselByType,
  },

  computed: {
    isMobile() {
      return this.$store.state.global.mobile;
    },
  },

  methods: {
    scroll() {
      window.scrollTo({
        top: window.innerHeight - (this.isMobile ? 270 : 165),
        behavior: "smooth",
      });
    },
  },
};
